import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  CardHeader,
  IconButton,
  List,
  ListItem,
  Paper,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const ReservationsOverlay = ({reservations, innerRef, onClose}) => {
  return (
    <Paper
      ref={innerRef}
      sx={{
        height: '100%',
      }}
      className="pl-mode-dark"
    >
      <CardHeader
        action={
          <IconButton size="small" onClick={onClose} sx={{padding: 0.5}}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{paddingTop: 1, paddingBottom: 0, paddingRight: 1.25}}
      />
      <Box sx={{padding: 1}}>
        <List dense disablePadding>
          {reservations.map(r => (
            <ListItem key={r.id} dense disableGutters>
              <Typography variant="body2">{r.title}</Typography>
            </ListItem>
          ))}
        </List>
      </Box>
    </Paper>
  );
};

ReservationsOverlay.propTypes = {
  reservations: PropTypes.array,
  onClose: PropTypes.func,
  innerRef: PropTypes.func,
};

export default ReservationsOverlay;
